import { graphql } from "react-relay";
import { InviteCard } from "@components/invite-card";
import { OrgInvite } from "@components/org-invite";
import { CopyPersonalInviteLinkBtn } from "@components/copy-personal-invite-link-btn";

export const fragments = {
  viewer: graphql`
    fragment OrgInvite_viewer on Viewer
    @argumentDefinitions(
      queryInput: { type: "String!", defaultValue: "" }
      orgRelayId: { type: "ID!", defaultValue: "" }
      excludeCalendars: { type: "[String]" }
    ) {
      user {
        ...CopyPersonalInviteLinkBtn_user
      }
      personQueryResultErrorable(
        query: $queryInput
        orgRelayId: $orgRelayId
        excludeCalendars: $excludeCalendars
      ) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on PersonQueryResult {
          query
          persons {
            id
            primaryEmail
            emails
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isUser
          }
        }
      }
    }
  `,
  org: graphql`
    fragment OrgInvite_org on Org {
      id
      ...InviteCard_org
      ...CopyPersonalInviteLinkBtn_org
      personCorpusErrorable {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on PersonList {
          list {
            primaryEmail
            emails
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isUser
          }
        }
      }
      suggestedInvites(first: 1000000) {
        edges {
          node {
            id
            targetCalendarId
            targetProfile {
              givenName
              familyName
              externalImageUrl
            }
            resolution
            numberOfSharedMeetings
            numberOfOrganizedMeetings
            inviteReason
            totalScore
          }
        }
      }
      pendingInvites(first: 1000000) {
        edges {
          node {
            id
            targetCalendarId
            lastSentTime
            targetProfile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query OrgInviteQuery($queryInput: String!, $orgRelayId: ID!, $excludeCalendars: [String]) {
    viewer {
      ... on Viewer {
        ...OrgInvite_viewer
          @arguments(
            queryInput: $queryInput
            orgRelayId: $orgRelayId
            excludeCalendars: $excludeCalendars
          )
      }
    }
  }
`;
